import type { FeatureContext } from '../../types';

import './health.css';

export function HealthFeature({ health }: FeatureContext) {
  return (
    <section className="page-section health">
      <h2>Backend Health</h2>
      {health ? (
        <pre className="health__payload">{JSON.stringify(health, null, 2)}</pre>
      ) : (
        <p className="health__placeholder">Backend health has not been loaded yet.</p>
      )}
    </section>
  );
}
